import React from "react";
import "./App.scss";
import Home from "./components/Home/Home";
import WritingList from "./components/Writing/components/WritingList";
import Article from "./components/Writing/components/Article";

import Paths from "./paths.json";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <Switch>
        {Paths.map((path) => {
          return (
            <Route
              key={path.extension}
              path={path.extension}
              exact
              component={() => {
                window.location.href = path.url;
                return null;
              }}
            />
          );
        })}
        <Route path="/writing" exact component={WritingList} />
        <Route path="/writing/:slug" exact component={Article} />
        <Route path="/" component={Home} />
      </Switch>
    </Router>
  );
};

export default App;
